import ColorPickerModal from "../modals/ColorPickerModal";
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllObjects } from "../../data/getters";
import { updateTables } from "../../data/store/actions/objectStoreFunctions";
import createdTablesApi from "../../data/api/createdTablesApi";
import createdItemApi from "../../data/api/createdItemApi";
import { useParams } from "react-router-dom";
import TableItemsList from "../helpers/TableItemsList";
import { Button, Modal } from "react-bootstrap";
import {
  parsePositions,
  makeInstanceIds,
  normalizeWorkForCompare,
  normalizeTableForCompare,
  buildItemUpdatePayload,
  diffChangedItems,
  rebuildProcessed,
  resolveColorName as resolveColorNameUtil,
  buildProcessedItemsFromBackend,
  rewriteItemTableIds,
  mergeGeneratedTablesWithExisting
} from "../../modules/helpers/tableViewerUtil";
import { useGenerateTables } from "../../calculation/generateTables/generateTables";
import {
  exportByWork,
  exportByColor,
  exportSeparately
} from "../../export/exportTables";
import { exportSizeListPdf } from "../../export/exportSizeListPdf";
import isEqual from "lodash/isEqual";
import workApi from "../../data/api/workApi";
import { mergePreprocessedItems, preprocessingChangesGeometry } from "../helpers/workPreprocessing";
import { updateWork } from "../../data/store/actions/workStoreFunctions";
import ExportModal from "../modals/ExportModal";
import GenerateModal from "../modals/GenerateModal";
import { TableViewerComponent } from "./TableViewerComponent";
import { useLanguage } from "../helpers/LanguageContext";
import "../../css/TableViewer.css";

const TableViewer = () => {
  const [isAddingItem, setIsAddingItem] = useState(false);
  const { t } = useLanguage();
  const dispatch = useDispatch();
  const { workId } = useParams();
  const generateTables = useGenerateTables();
  // const [createdTables, setCreatedTables] = useState([]);
  const [createdItems, setCreatedItems] = useState([]);
  const [processedItems, setProcessedItems] = useState([]);
  const [currentTableIndex, setCurrentTableIndex] = useState(0);
  const [dividerPosition, setDividerPosition] = useState(70);
  const [selectedItemPosition, setSelectedItemPosition] = useState(null);
  const [placementItemId, setPlacementItemId] = useState(null);
  const [placementRotation, setPlacementRotation] = useState(null);
  const [placementForceRotate, setPlacementForceRotate] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedTables, setEditedTables] = useState([]);
  const [editedItems, setEditedItems] = useState([]);
  const [showNoTableText, setShowNoTableText] = useState(false);
  const containerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedColorId, setSelectedColorId] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [collapsedColors, setCollapsedColors] = useState({});
  const colorsFromStore = useSelector((state) => state.colors);
  const [trimSize, setTrimSize] = useState(10);
  const [generateDirection, setGenerateDirection] = useState("both");
  const [allowHalfTable, setAllowHalfTable] = useState(true);
  const millings = useSelector((state) => state.millings);
  useEffect(() => {
    console.log("colorsFromStore: ", colorsFromStore);
  }, [colorsFromStore]);

  const [exportMode, setExportMode] = useState("work"); // work | colors | tables
  const [selectedColorIds, setSelectedColorIds] = useState([]);
  const [selectedTableIds, setSelectedTableIds] = useState([]);
  const [showExportModal, setShowExportModal] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);
  const [itemsFilterMode, setItemsFilterMode] = useState("all");
  const showMessage = (type, text) => {
    setStatusMessage({ type, text });
    setTimeout(() => setStatusMessage(null), 3500);
  };
  const pendingWorkRef = useRef(null);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [preprocessBeforeGenerate, setPreprocessBeforeGenerate] = useState(true);
  const generationRequestRef = useRef(false);
  const generatedWorkIdsRef = useRef(new Set());
  const [generateScope, setGenerateScope] = useState("work");
  const [generateMode, setGenerateMode] = useState("full");
  const [selectedGenerateColorIds, setSelectedGenerateColorIds] = useState([]);
  const [selectedGenerateTableIds, setSelectedGenerateTableIds] = useState([]);
  const allCreatedTables = useSelector((state) => state.createdTables);
  const createdTables = useMemo(() => {
    return allCreatedTables.filter(
      (t) => String(t.work?.workId) === String(workId)
    );
  }, [allCreatedTables, workId]);
  const workingTables = useMemo(() => {
    return isEditing ? editedTables : createdTables;
  }, [isEditing, editedTables, createdTables]);
  useEffect(() => {
    if (createdTables.length > 0 || workingTables.length > 0) {
      generatedWorkIdsRef.current.add(String(workId));
    }
  }, [createdTables, workingTables, workId]);
  function debugDiffById(label, prev, next, key = "itemId") {
    /* console.group(`🧩 DIFF → ${label}`);

    const prevMap = new Map(prev.map((o) => [o[key], o]));
    const nextMap = new Map(next.map((o) => [o[key], o]));

    for (const [id, before] of prevMap) {
      const after = nextMap.get(id);
      if (!after) {
        console.log("➖ Removed:", before);
        continue;
      }
      if (!isEqual(before, after)) {
        console.group(`🔁 Changed id=${id}`);
        console.log("BEFORE:", before);
        console.log("AFTER :", after);
        console.groupEnd();
      }
    }

    for (const [id, after] of nextMap) {
      if (!prevMap.has(id)) {
        console.log("➕ Added:", after);
      }
    }

    console.groupEnd();*/
  }

  const [objects, setObjects] = useState([]);
  useEffect(() => {
    const allObjects = dispatch(getAllObjects());
    console.log(
      "allObjects: ",
      allObjects.filter((o) => o.work?.workId === +workId)
    );
    setObjects(allObjects.filter((o) => o.work?.workId === +workId));
  }, [workId]);

  const usedColors = useMemo(() => {
    const map = new Map();
    createdTables.forEach((t) => {
      const cid = t.color?.colorId;
      if (cid != null) {
        const full = colorsFromStore.find((c) => c.colorId === cid);
        if (full) map.set(cid, full);
      }
    });
    return Array.from(map.values());
  }, [createdTables, colorsFromStore]);

  const resolveColorName = useCallback(
    (t) => resolveColorNameUtil(t, colorsFromStore),
    [colorsFromStore]
  );
  const usedTables = useMemo(() => {
    return createdTables.map((tbl) => ({
      id: tbl.id,
      label: `${t("tableLabel")} ${tbl.id} (${resolveColorName(tbl)})`
    }));
  }, [createdTables, resolveColorName, t]);
  const handleConfirmedExport = async () => {
    const sourceTables = (isEditing ? editedTables : createdTables).map((table) => ({
      ...table,
      color: colorsFromStore.find((color) => String(color.colorId) === String(table.color?.colorId)) ?? table.color,
      milling: millings.find((milling) => String(milling.millingId) === String(table.milling?.millingId)) ?? table.milling
    }));
    const sourceItems = isEditing ? editedItems : processedItems;

    if (sourceTables.length === 0) return;

    const workObj = {
      workId,
      username: selectedWork?.user?.name || "user",
      clientName: selectedWork?.client?.name
    };

    try {
      if (exportMode === "work") {
        await runWithLock(exportLock, async () => {
          await exportByWork(workObj, sourceTables, sourceItems);
        });
      }

      if (exportMode === "colors") {
        await exportByColor(
          workObj,
          sourceTables,
          selectedColorIds,
          sourceItems
        );
      }

      if (exportMode === "tables") {
        const selectedIds = new Set(selectedTableIds.map(String));
        const filtered = sourceTables.filter((table) =>
          selectedIds.has(String(table.id))
        );
        await exportSeparately(workObj, filtered, sourceItems);
      }

      setShowExportModal(false);
    } catch (error) {
      console.error("A ZIP-export nem készült el:", error);
      showMessage("error", error?.message || t("exportFailed"));
    }
  };

  async function saveGeneratedTables(itemsSource = null, tablesSource = null) {
    const sourceItems =
      itemsSource ??
      (isEditing
        ? editedItems
        : Array.isArray(processedItems)
          ? processedItems
          : createdItems);

    const sourceTables =
      tablesSource ?? (isEditing ? editedTables : createdTables);

    const newOnes = sourceTables.filter((table) => Number(table.id) < 0);

    const idMap = {};

    /*
     * Új táblák létrehozása a backendben.
     */
    for (const table of newOnes) {
      const created = await dispatch(
        createdTablesApi.createCreatedTablesApi({
          ...table,
          id: undefined
        })
      );

      const createdId = Number(created?.id);

      if (!Number.isFinite(createdId) || createdId <= 0) {
        throw new Error(`CREATED_TABLE_INVALID_ID:${table.id}`);
      }

      idMap[String(table.id)] = createdId;
    }

    /*
     * Negatív ideiglenes table ID-k átírása.
     */
    const updatedTables = sourceTables
      .map((table) => {
        const realId = idMap[String(table.id)];

        if (realId === undefined) {
          return table;
        }

        return {
          ...table,
          id: realId,
          frontend: false
        };
      })
      .sort((a, b) => Number(a.id) - Number(b.id));

    /*
     * Az itemek tablePosition és processedPositions
     * mezőiben is átírjuk a table ID-ket.
     */
    const hasTemporaryTableReferences = (item) => {
      const mappedTemporaryIds = new Set(Object.keys(idMap).map(String));

      if (mappedTemporaryIds.size === 0) {
        return false;
      }

      const hasInProcessedPositions = (item.processedPositions || []).some(
        (position) => mappedTemporaryIds.has(String(position.id))
      );

      if (hasInProcessedPositions) {
        return true;
      }

      const hasInTablePosition = parsePositions(item.tablePosition || "").some(
        (position) => mappedTemporaryIds.has(String(position[3]))
      );

      return hasInTablePosition;
    };

    /*
     * Fontos:
     * Új üres tábla hozzáadásakor az itemekhez nem nyúlunk.
     * Csak azokat írjuk át, amelyek tényleg negatív ideiglenes
     * table ID-ra hivatkoznak.
     */
    const itemsNeedTableIdRewrite = sourceItems.some(
      hasTemporaryTableReferences
    );

    const rewrittenItems = itemsNeedTableIdRewrite
      ? rewriteItemTableIds(sourceItems, idMap, parsePositions)
      : sourceItems;

    dispatch(updateTables(updatedTables));

    setCreatedItems(rewrittenItems);
    setProcessedItems(rewrittenItems);
    setEditedItems(rewrittenItems);
    setEditedTables(updatedTables);

    return {
      items: rewrittenItems,
      tables: updatedTables
    };
  }

  const validateSizeListPreconditions = () => {
    const hasUnsavedChanges = hasDirty;
    const hasTables = createdTables.length > 0;

    const savedTables = createdTables.every((table) => table.id > 0);
    const savedItems = createdItems.every((item) => item.itemId > 0);

    const tableIds = new Set(createdTables.map((table) => table.id));

    const everyItemPlacedOnTable = createdItems.every((item) => {
      const qty = Number(item.qty ?? 0);
      const positions = parsePositions(item.tablePosition);

      if (qty <= 0) return true;

      return (
        positions.length >= qty &&
        positions.every((pos) => tableIds.has(pos[3]))
      );
    });

    return {
      valid:
        !hasUnsavedChanges &&
        hasTables &&
        savedTables &&
        savedItems &&
        everyItemPlacedOnTable,
      hasUnsavedChanges,
      hasTables,
      savedTables,
      savedItems,
      everyItemPlacedOnTable
    };
  };
  const handlePlacementRequest = (item) => {
    const itemId = item?.itemId;

    if (itemId == null) return;

    if (!currentTable) {
      showMessage("error", t("selectTableFirst"));
      return;
    }

    const requestedRotation = Number(item?.placementRotation) === 1 ? 1 : 0;

    const requestedForceRotate = Boolean(item?.forceRotationAllowed);

    const isAlreadySelected =
      placementItemId != null &&
      String(placementItemId) === String(itemId) &&
      placementRotation === requestedRotation;

    if (isAlreadySelected) {
      setPlacementItemId(null);
      setPlacementRotation(null);
      setPlacementForceRotate(false);

      showMessage("info", t("placementSelectionCancelled"));
      return;
    }

    if (!isEditing) {
      startEditing();
    }

    setSelectedItemPosition(null);
    setPlacementItemId(itemId);
    setPlacementRotation(requestedRotation);
    setPlacementForceRotate(requestedForceRotate);

    showMessage(
      "info",
      requestedRotation === 1
        ? t("placementHintVertical")
        : t("placementHintHorizontal")
    );
  };

  useEffect(() => {
    if (!isEditing) {
      setPlacementItemId(null);
      setPlacementRotation(null);
      setPlacementForceRotate(false);
    }
  }, [isEditing]);
  const handleSizeListClick = () => {
    const result = validateSizeListPreconditions();

    if (result.valid) {
      const groupedByColor = createdItems.reduce((acc, item) => {
        const colorId = item.color?.colorId;

        if (!acc[colorId]) {
          acc[colorId] = [];
        }

        acc[colorId].push(item);
        return acc;
      }, {});
      Object.entries(groupedByColor).forEach(([colorId, items]) => {
        const color = colorsFromStore.find(
          (c) => String(c.colorId) === String(colorId)
        );

        exportSizeListPdf({
          work: selectedWork,
          color,
          items,
          currentTable,
          createdTables,
          millings
        });
      });

      showMessage("success", t("sizeListGenerated"));
      return;
    }

    if (result.hasUnsavedChanges) {
      showMessage("error", t("sizeListUnsavedChanges"));
      return;
    }

    if (!result.hasTables) {
      showMessage("error", t("sizeListNoTables"));
      return;
    }

    if (!result.savedTables || !result.savedItems) {
      showMessage("error", t("sizeListSaveRequired"));
      return;
    }

    if (!result.everyItemPlacedOnTable) {
      showMessage("error", t("sizeListItemsUnplaced"));
    }
  };

  const generateLock = useRef(false);
  const saveLock = useRef(false);
  const exportLock = useRef(false);

  const runWithLock = async (lockRef, fn) => {
    if (lockRef.current) return;
    lockRef.current = true;
    try {
      return await fn();
    } finally {
      lockRef.current = false;
    }
  };

  const [palette, setPalette] = useState([]);

  const currentUser = useSelector((state) => state.auth.user);
  useEffect(() => {
    const itemColorIds = Array.from(
      new Set(
        createdItems
          .filter(Boolean) // 🔥 EZ KELL
          .map((it) => it?.color?.colorId)
          .filter((cid) => cid != null)
      )
    );
    setPalette((prev) => {
      const allIds = Array.from(
        new Set([...prev.map((c) => c.colorId), ...itemColorIds])
      );
      return allIds
        .map((id) => colorsFromStore.find((c) => c.colorId === id))
        .filter(Boolean);
    });
  }, [createdItems, colorsFromStore]);
  const allWorks = useSelector((state) =>
    Array.isArray(state.works)
      ? state.works
      : state.works?.work
        ? [state.works.work]
        : []
  );

  const selectedWork = allWorks.find((w) => w.workId == workId);
  const isOrdered = selectedWork?.isOrdered;

  const cannotEdit =
    (currentUser.role === "user" && isOrdered) ||
    ((currentUser.role === "companyAdmin" ||
      currentUser.role === "companyUser") &&
      selectedWork?.companyStatus === "Completed") ||
    ((currentUser.role === "companyAdmin" ||
      currentUser.role === "companyUser") &&
      !isOrdered);
  const canEdit = !cannotEdit;
  const workBaselineInitialized = useRef(false);

  useEffect(() => {
    if (!selectedWork || workBaselineInitialized.current) return;

    originalWorkRef.current = structuredClone(selectedWork);
    workBaselineInitialized.current = true;
  }, [selectedWork]);

  const [swapSourceColor, setSwapSourceColor] = useState(undefined); // null = "nincs szín", szám = colorId
  const [showPaletteModal, setShowPaletteModal] = useState(false);

  const closePalette = () => {
    setShowPaletteModal(false);
    setSwapSourceColor(undefined);
  };
  // Tömeges színcsere kiválasztott cél színre
  const selectPalettePatch = async (patch, requiresRegenerate = false) => {
    try {
      // Mely tételek színeit kell cserélni?
      const match = (it) =>
        swapSourceColor === null
          ? it.color?.colorId == null
          : it.color?.colorId === swapSourceColor;
      const toChange = createdItems.filter(match);
      if (!toChange.length) {
        closePalette();
        return;
      }
      // Payloadok a backendnek (teljes, kanonizált frissítés – csak a színt módosítjuk)
      const payloads = toChange
        .filter((it) => typeof it.itemId === "number" && it.itemId > 0)
        .map((it) => ({
          itemId: it.itemId,
          ...buildItemUpdatePayload({
            ...it,
            ...patch
          }),
          tablePosition: it.tablePosition ?? ""
        }));
      await runWithLock(saveLock, async () => {
        await dispatch(
          createdItemApi.updateMultipleCreatedItemsApi(payloads, {
            requiresRegenerate
          })
        );
      });

      // Lokális state azonnali frissítése (ne legyen “dirty” eltérés)
      const updated = createdItems.map((it) =>
        match(it)
          ? {
              ...it,
              ...patch
            }
          : it
      );
      setCreatedItems(updated);
      originalItemsRef.current = updated;
      onDirty(false);
    } catch (e) {
      console.error("Bulk color swap failed:", e);
      alert(t("colorSwapFailed"));
    } finally {
      closePalette();
    }
  };

  const safeClone = (x) => {
    try {
      return structuredClone(x);
    } catch {
      return x;
    }
  };

  // --- tétel frissítés ---
  const [hasDirty, onDirty] = useState(false);
  const originalItemsRef = useRef([]); // betöltés után snapshot
  const originalTablesRef = useRef([]);
  const originalWorkRef = useRef(null);
  const generatedSavePendingRef = useRef(false);
  const patchItemAtIndex = useCallback((source, index, fields) => {
    const arr = Array.isArray(source) ? [...source] : [];
    const cur = arr[index];

    if (!cur) return arr;

    const next = { ...cur, ...fields };

    if ("color" in fields) {
      next.color = fields.color ?? null;
      delete next.colorName;
      delete next.color_id;
    }

    if ("sizeArr" in fields) {
      delete next.sizeArr;
    }

    if ("cantType" in fields || "longCant" in fields || "shortCant" in fields) {
      delete next.cantType;
      delete next.longCant;
      delete next.shortCant;
    }

    arr[index] = next;
    return arr;
  }, []);

  const handleCreatedItemChange = useCallback(
    (index, fields) => {
      const updater = (source) => patchItemAtIndex(source, index, fields);

      if (isEditing) {
        setEditedItems(updater);
      } else {
        setCreatedItems(updater);
        setProcessedItems(updater);
      }

      onDirty(true);
    },
    [isEditing, patchItemAtIndex]
  );

  const normalizeForCompare = (x) => {
    // ugyanazzal a builderrel képezd le, mint a küldendő payloadot
    const base = buildItemUpdatePayload(x);
    // a pozíció is számítson
    return {
      itemId: x.itemId,
      ...base,
      tablePosition: x.tablePosition ?? ""
    };
  };

  const handleDeleteItem = async (itemIds) => {
    if (!itemIds || itemIds.length === 0) return;

    try {
      await runWithLock(saveLock, async () => {
        await dispatch(createdItemApi.deleteMultipleCreatedItemsApi(itemIds));
      });

      // 🔥 Local state sync
      setCreatedItems((prev) =>
        prev.filter((it) => !itemIds.includes(it.itemId))
      );
    } catch (err) {
      console.error("Bulk delete failed:", err);
    }
  };
  const loadDataImpl = async () => {
    try {
      setIsLoading(true);
      const tables1 =
        await createdTablesApi.getAllCreatedTablesForWorkApi(workId);
      console.log("Loaded tables: ", tables1);
      const backendTables = tables1.map((t) => ({ ...t, id: t.id }));
      const rawItems =
        await createdItemApi.getAllCreatedItemsForWorkApi(workId);
      const backendItems = rawItems.map((it) => ({
        ...it,
        color: it.color ? { colorId: it.color.colorId } : null
      }));
      //.filter((it) => it.frontend !== true);
      const items = backendItems;
      const tables = backendTables;
      console.log("Loaded items: ", items);
      setCreatedItems(items);
      //setCreatedTables(tables);
      dispatch(updateTables(tables));
      originalItemsRef.current = items;
      originalTablesRef.current = tables;

      onDirty(false);
      const processed = buildProcessedItemsFromBackend(
        items,
        parsePositions,
        makeInstanceIds
      );
      setProcessedItems(processed);

      setShowNoTableText(tables.length === 0);
      setIsLoading(false);
    } catch (err) {
      console.error("Error loading data:", err);
    }
  };

  // Publikus betöltő, ami már single-flight lockkal fut
  const loadData = async () => runWithLock(saveLock, loadDataImpl);

  const buildGeneratedWorkPayload = (work) => {
    if (!work) return null;

    const payload = {
      workId: Number(work.workId),

      cutLength: work.cutLength,
      kantLength: work.kantLength,
      partCount: work.partCount,
      measureCount: work.measureCount,
      tableUsage: work.tableUsage,
      usedTables: work.usedTables,
      woodPrice: work.woodPrice,
      clientPrice: work.clientPrice
    };

    /*
     * Ne küldjünk undefined mezőket.
     * Főleg ne küldjük vissza a teljes work objektum
     * esetleges kapcsolt item-, table- vagy object-listáit.
     */
    return Object.fromEntries(
      Object.entries(payload).filter(([, value]) => value !== undefined)
    );
  };
  // --- bulk mentés ---
  const saveDirtyItemsIfAny = async (
    requiresRegenerate = true,
    itemsOverride = null,
    tablesOverride = null,
    forceItemSave = false
  ) => {
    const startTime = performance.now();
    console.groupCollapsed("💾 SAVE START");
    const tablesToSave =
      tablesOverride ?? (isEditing ? editedTables : createdTables);

    const itemsToSave =
      itemsOverride ??
      (isEditing
        ? editedItems
        : Array.isArray(processedItems)
          ? processedItems
          : createdItems);
    const currentWork = pendingWorkRef.current ?? selectedWork;

    const workChanged = !isEqual(
      normalizeWorkForCompare(currentWork),
      normalizeWorkForCompare(originalWorkRef.current)
    );

    if (!hasDirty && !itemsOverride && !workChanged) {
      console.log("⏭ No changes detected.");
      console.groupEnd();
      showMessage("info", t("noChangesToSave"));
      return;
    }

    try {
      const merged = structuredClone(itemsToSave);

      const changedItems = forceItemSave
        ? merged.filter((item) => {
            const itemId = Number(item.itemId);

            return Number.isFinite(itemId) && itemId > 0;
          })
        : diffChangedItems(originalItemsRef.current, merged);
      const normalizedCurrentTables = tablesToSave.map(
        normalizeTableForCompare
      );
      const normalizedOriginalTables =
        originalTablesRef.current?.map(normalizeTableForCompare) ?? [];

      console.group("🔍 TABLES COMPARE");

      console.log("CURRENT raw:", createdTables);
      console.log("ORIGINAL raw:", originalTablesRef.current);

      console.log("CURRENT normalized:", normalizedCurrentTables);
      console.log("ORIGINAL normalized:", normalizedOriginalTables);

      console.table(
        normalizedCurrentTables.map((cur) => {
          const orig = normalizedOriginalTables.find((o) => o.id === cur.id);

          return {
            id: cur.id,
            currentTrim: cur.trim,
            originalTrim: orig?.trim,
            currentTRIM: cur.TRIM,
            originalTRIM: orig?.TRIM,
            trimEqual: cur.trim === orig?.trim,
            wholeEqual: isEqual(cur, orig)
          };
        })
      );

      console.groupEnd();

      const tablesChanged = !isEqual(
        normalizedCurrentTables,
        normalizedOriginalTables
      );

      console.log("🔍 Tables changed:", tablesChanged);

      console.log("🔍 Work changed:", workChanged);
      console.log("🔍 Tables changed:", tablesChanged);
      console.log("🔍 Items changed:", changedItems.length);

      if (changedItems.length === 0 && !tablesChanged && !workChanged) {
        console.log("⏭ No effective differences.");
        console.groupEnd();
        onDirty(false);
        showMessage("info", t("noChangesToSave"));
        return;
      }

      // ======================
      // 🟢 TABLE UPDATE
      // ======================
      if (tablesChanged) {
        const tablePayloads = tablesToSave
          .filter((table) => table.id > 0)
          .map((table) => ({
            id: table.id,
            ...normalizeTableForCompare(table)
          }));

        console.log("📦 TABLE PAYLOADS:", tablePayloads);

        await dispatch(
          createdTablesApi.updateMultipleCreatedTablesApi(tablePayloads)
        );
      }
      // ======================
      // 🟢 WORK UPDATE
      //
      // A work mentése az itemek ELŐTT történjen.
      // Csak a generálás által módosított work mezőket küldjük.
      // ======================
      if (workChanged) {
        const workPayload = buildGeneratedWorkPayload(currentWork);

        console.log("📦 WORK PAYLOAD:", workPayload);

        await dispatch(
          workApi.updateWorkApi(Number(currentWork.workId), workPayload)
        );

        originalWorkRef.current = structuredClone(currentWork);

        pendingWorkRef.current = null;
      }

      // ======================
      // 🟢 ITEM UPDATE
      //
      // Az item mentés legyen az UTOLSÓ írási művelet,
      // hogy semmilyen későbbi work update ne tudja
      // visszaírni a korábbi tablePosition értéket.
      // ======================
      const itemPayloads = changedItems
        .filter((item) => {
          const itemId = Number(item.itemId);

          return Number.isFinite(itemId) && itemId > 0;
        })
        .map((item) => ({
          itemId: Number(item.itemId),

          ...buildItemUpdatePayload(item),

          tablePosition: String(item.tablePosition ?? "")
        }));

      console.table(
        itemPayloads.map((item) => ({
          itemId: item.itemId,
          tablePositionLength: item.tablePosition.length,
          tablePosition: item.tablePosition
        }))
      );

      if (itemPayloads.length > 0) {
        const itemUpdateResult = await dispatch(
          createdItemApi.updateMultipleCreatedItemsApi(itemPayloads, {
            requiresRegenerate: false
          })
        );

        console.log("✅ ITEM UPDATE RESPONSE:", itemUpdateResult);
      }
      if (itemPayloads.length > 0) {
        const backendItems =
          await createdItemApi.getAllCreatedItemsForWorkApi(workId);

        const backendById = new Map(
          (backendItems || []).map((item) => [String(item.itemId), item])
        );

        const tablePositionMismatches = itemPayloads
          .map((payload) => {
            const backendItem = backendById.get(String(payload.itemId));

            const expected = String(payload.tablePosition ?? "");

            const actual = String(backendItem?.tablePosition ?? "");

            if (expected === actual) {
              return null;
            }

            return {
              itemId: payload.itemId,
              expected,
              actual
            };
          })
          .filter(Boolean);

        if (tablePositionMismatches.length > 0) {
          console.error(
            "❌ A backend nem a küldött tablePosition értéket tárolta:",
            tablePositionMismatches
          );

          throw new Error("TABLE_POSITION_SAVE_VERIFICATION_FAILED");
        }

        console.log("✅ Minden generált tablePosition visszaellenőrizve.");
      }
      // ======================
      // ✅ SUCCESS
      // ======================
      originalItemsRef.current = structuredClone(merged);
      originalTablesRef.current = structuredClone(tablesToSave);

      dispatch(updateTables(structuredClone(tablesToSave)));

      setCreatedItems(structuredClone(merged));
      setProcessedItems(structuredClone(merged));

      setEditedItems(structuredClone(merged));
      setEditedTables(structuredClone(tablesToSave));

      onDirty(false);
      const duration = (performance.now() - startTime).toFixed(1);
      console.log(`✅ SAVE SUCCESS (${duration}ms)`);
      console.groupEnd();

      showMessage("success", t("saveSuccess"));
    } catch (error) {
      console.error("❌ SAVE FAILED:", error);
      console.groupEnd();
      showMessage("error", t("saveFailed"));
      throw error;
    }
  };

  const [showPreGenerateSaveModal, setShowPreGenerateSaveModal] =
    useState(false);
  const pendingGenerateConfigRef = useRef(null);

  const actuallyGenerate = async ({
    scope,
    mode,
    colorIds = [],
    tableIds = [],
    TRIM,
    direction,
    allowHalfTable,
    preprocessedItems = null
  }) => {
    setIsLoading(true);
    showMessage("info", t("generatingInProgress"));
    const rawSource = preprocessedItems ?? (
      mode === "lines"
        ? isEditing
          ? editedItems
          : createdItems
        : scope === "tables"
          ? isEditing
            ? editedItems
            : createdItems
          : originalItemsRef.current);
    const normalizePositions = (items) =>
      items.map((item) => ({
        ...item,

        tablePosition: (item.processedPositions || [])
          .map((position) => {
            const datiRowNumber = Number(position.datiRowNumber);

            const safeDatiRowNumber =
              Number.isInteger(datiRowNumber) && datiRowNumber > 0
                ? datiRowNumber
                : 0;

            return (
              `[${position.x},` +
              `${position.y},` +
              `${position.rotation},` +
              `${position.id},` +
              `${safeDatiRowNumber}]`
            );
          })
          .join(",")
      }));
    const baseSource = normalizePositions(rawSource);
    /* const baseSource =
      mode === "lines"
        ? isEditing
          ? editedItems
          : createdItems
        : scope === "tables"
          ? isEditing
            ? editedItems
            : createdItems
          : originalItemsRef.current;*/
    const originalSnapshot =
      process.env.NODE_ENV === "development"
        ? structuredClone(baseSource)
        : baseSource;
    let resetItems = originalSnapshot;

    if (scope === "work" && mode !== "lines") {
      resetItems = originalSnapshot.map((it) => ({
        ...it,
        tablePosition: "",
        processedPositions: []
      }));
    }

    if (scope === "colors" && mode !== "lines") {
      resetItems = originalSnapshot.map((it) =>
        colorIds.includes(it.color?.colorId)
          ? { ...it, tablePosition: "", processedPositions: [] }
          : it
      );
    }

    if (scope === "tables" && mode !== "lines") {
      resetItems = originalSnapshot.map((it) => {
        const positions = parsePositions(it.tablePosition);

        const toRegenerate = positions.filter((p) => tableIds.includes(p[3]));

        if (toRegenerate.length === 0) {
          return it;
        }

        const remaining = positions.filter((p) => !tableIds.includes(p[3]));
        if (mode !== "lines") {
          return {
            ...it,
            tablePosition: remaining
              .map(([x, y, rotation, id, rawDatiRowNumber]) => {
                const datiRowNumber = Number(rawDatiRowNumber);

                return (
                  `[${x},${y},${rotation},${id},` +
                  `${
                    Number.isInteger(datiRowNumber) && datiRowNumber > 0
                      ? datiRowNumber
                      : 0
                  }]`
                );
              })
              .join(","),
            processedPositions: (it.processedPositions || []).filter(
              (p) => !tableIds.includes(p.id)
            ),
            generateQty: toRegenerate.length
          };
        } else {
          return {
            ...it,
            generateQty: toRegenerate.length
          };
        }
      });
    }
    // console.log("resetItems: ", resetItems);
    setCreatedItems(resetItems);
    setProcessedItems(resetItems);

    await runWithLock(generateLock, async () => {
      /*
       * Itt készül el a generated változó.
       */
      const generated = await Promise.resolve(
        generateTables(
          workId,
          {
            scope,
            mode,
            colorIds,
            tableIds,
            TRIM: Number(TRIM ?? trimSize),
            direction: direction ?? generateDirection,
            allowHalfTable
          },
          resetItems,
          createdTables
        )
      );

      /*
       * Hibás generátorválasz esetén ne fusson tovább a feldolgozás.
       */
      if (
        !generated ||
        !Array.isArray(generated.createdItems) ||
        !Array.isArray(generated.createdTables)
      ) {
        throw new Error("INVALID_GENERATOR_RESPONSE");
      }

      /*
       * Nincs második table-ID merge.
       * A generateTables már a végleges táblalistát adja vissza.
       */
      const finalGeneratedTables = generated.createdTables.map((table) => ({
        ...table
      }));

      const processed = generated.createdItems.map((item) => {
        const positions = parsePositions(item.tablePosition);
        const [origH, origW] = JSON.parse(item.size || "[0,0]");

        const instanceIds = makeInstanceIds(item.itemId, positions.length);

        const rewrittenPositions = positions.map(
          ([x, y, rotation, id, rawDatiRowNumber]) => {
            const datiRowNumber = Number(rawDatiRowNumber);

            return [
              x,
              y,
              rotation,
              id,
              Number.isInteger(datiRowNumber) && datiRowNumber > 0
                ? datiRowNumber
                : 0
            ];
          }
        );

        return {
          ...item,

          tablePosition: rewrittenPositions
            .map(
              ([x, y, rotation, id, datiRowNumber]) =>
                `[${x},${y},${rotation},${id},${datiRowNumber}]`
            )
            .join(","),

          processedPositions: rewrittenPositions.map(
            ([x, y, rotation, id, datiRowNumber], idx) => {
              const isRotated = rotation === 1;
              const width = isRotated ? origH : origW;
              const height = isRotated ? origW : origH;

              return {
                instanceId: instanceIds[idx] ?? `${item.itemId}_${idx}`,
                x,
                y,
                rotation,
                id,
                width,
                height,
                datiRowNumber:
                  Number.isInteger(Number(datiRowNumber)) &&
                  Number(datiRowNumber) > 0
                    ? Number(datiRowNumber)
                    : null
              };
            }
          )
        };
      });

      // Innen folytatódhat a meglévő:
      // let finalItems;
      // if (scope === "work") ...

      let finalItems;

      if (scope === "work") {
        finalItems = processed;
      } else if (scope === "colors") {
        const processedMap = new Map(processed.map((it) => [it.itemId, it]));

        finalItems = originalSnapshot.map((originalItem) => {
          const regenerated = processedMap.get(originalItem.itemId);

          if (!regenerated) {
            return rebuildProcessed(
              originalItem,
              parsePositions,
              makeInstanceIds
            );
          }

          return {
            ...originalItem,
            tablePosition: regenerated.tablePosition,
            processedPositions: regenerated.processedPositions
          };
        });

        // 🔥 generateQty takarítás külön lépésben
        finalItems = finalItems.map((it) => {
          if (it.generateQty == null) return it;
          const clone = { ...it };
          delete clone.generateQty;
          return clone;
        });
      } else if (scope === "tables") {
        const processedMap = new Map(processed.map((it) => [it.itemId, it]));
        finalItems = originalSnapshot.map((originalItem) => {
          const regenerated = processedMap.get(originalItem.itemId);
          if (!regenerated) {
            return rebuildProcessed(
              originalItem,
              parsePositions,
              makeInstanceIds
            );
          }
          const result = {
            ...originalItem,
            tablePosition: regenerated.tablePosition,
            processedPositions: regenerated.processedPositions
          };

          console.log("result: ", result);
          return result;
        });
      } else {
        finalItems = processed;
      }

      if (process.env.NODE_ENV === "development") {
        debugDiffById(
          "ITEMS (FINAL)",
          originalSnapshot.map(normalizeForCompare),
          finalItems.map(normalizeForCompare),
          "itemId"
        );
      }

      //console.log("finalItems: ", finalItems);
      setCreatedItems(finalItems);
      setProcessedItems(finalItems);
      setEditedItems(finalItems);
      generatedSavePendingRef.current = true;

      const finalTables = finalGeneratedTables;

      dispatch(updateTables(finalTables));
      /*
      if (scope === "work") {
        finalTables = mergedTables;
      } else if (scope === "colors") {
        const originalTables = originalTablesRef.current ?? [];

        const untouched = originalTables.filter(
          (t) => !colorIds.includes(t.color?.colorId)
        );
        const map = new Map();

        [...untouched, ...mergedTables].forEach((t) => {
          map.set(t.id, t); // az utolsó felülírja az előzőt
        });

        finalTables = Array.from(map.values());
      } else if (scope === "tables") {
        const originalTables = originalTablesRef.current ?? [];

        const untouched = originalTables.filter(
          (t) => !colorIds.includes(t.color?.colorId)
        );
        const map = new Map();

        [...untouched, ...mergedTables].forEach((t) => {
          map.set(t.id, t); // az utolsó felülírja az előzőt
        });

        finalTables = Array.from(map.values());
      } else {
        finalTables = mergedTables;
      }
*/
      dispatch(updateTables(finalTables));
      //originalTablesRef.current = finalTables;
      if (generated.work) {
        dispatch(updateWork(generated.work));
        pendingWorkRef.current = generated.work;
        onDirty(true);
      }
      setShowNoTableText(generated.createdTables.length === 0);

      const realItemChanges = diffChangedItems(
        originalItemsRef.current,
        finalItems
      );
      const realTableChanges = !isEqual(
        originalTablesRef.current?.map(normalizeTableForCompare) ?? [],
        finalTables.map(normalizeTableForCompare)
      );
      const workChanged = generated.work
        ? !isEqual(
            normalizeWorkForCompare(generated.work),
            normalizeWorkForCompare(originalWorkRef.current)
          )
        : false;
      console.log("generated result: ", generated);
      /*    generated.createdTables.forEach((table) =>
           console.log("tableId: ", table.id, ", righe: ", table.righe)
      );*/
      const hasRealChanges =
        realItemChanges.length > 0 || realTableChanges || workChanged;
      onDirty(hasRealChanges);

      if (!hasRealChanges) {
        showMessage("info", t("generateAlreadyOptimal"));
      } else {
        showMessage("success", t("generateSuccess"));
      }
      setCurrentTableIndex(0);
    });

    setIsLoading(false);
  };
  const replaySingleTable = async ({ tableId, items, tables }) => {
    const sourceItems = Array.isArray(items) ? structuredClone(items) : [];

    const sourceTables = Array.isArray(tables) ? structuredClone(tables) : [];

    const targetTable = sourceTables.find(
      (candidate) => String(candidate.id) === String(tableId)
    );

    if (!targetTable) {
      throw new Error(`REPLAY_TARGET_TABLE_NOT_FOUND:${tableId}`);
    }

    /*
     * A generátornak mindig a legfrissebb manuális pozíciókat adjuk át.
     */
    const normalizedItems = sourceItems.map((item) => ({
      ...item,

      tablePosition: (item.processedPositions || [])
        .map((position) => {
          const datiRowNumber = Number(position.datiRowNumber);

          const safeDatiRowNumber =
            Number.isInteger(datiRowNumber) && datiRowNumber > 0
              ? datiRowNumber
              : 0;

          return (
            `[${position.x},${position.y},${position.rotation},` +
            `${position.id},${safeDatiRowNumber}]`
          );
        })
        .join(",")
    }));

    const result = await runWithLock(generateLock, async () => {
      const generated = await Promise.resolve(
        generateTables(
          workId,
          {
            scope: "tables",
            mode: "lines",

            colorIds:
              targetTable?.color?.colorId == null
                ? []
                : [targetTable.color.colorId],

            /*
             * Kizárólag ezt az egy táblát generáljuk újra.
             */
            tableIds: [targetTable.id],

            TRIM: Number(targetTable.trim ?? targetTable.TRIM ?? trimSize),

            allowHalfTable,
            direction: generateDirection
          },
          normalizedItems,
          sourceTables
        )
      );

      const returnedTables = Array.isArray(generated?.createdTables)
        ? generated.createdTables
        : [];

      /*
       * A generateTables a teljes visszamerge-elt táblalistát adja vissza,
       * ezért nem azt ellenőrizzük, hogy pontosan egy tábla érkezett-e.
       *
       * Kizárólag a célzott ID-jú táblát keressük meg.
       */
      const generatedTarget = returnedTables.find(
        (candidate) => String(candidate.id) === String(targetTable.id)
      );

      if (!generatedTarget) {
        throw new Error(
          `REPLAY_RESULT_TARGET_TABLE_NOT_FOUND:${targetTable.id}`
        );
      }

      const regeneratedTarget = {
        ...targetTable,
        ...generatedTarget,

        /*
         * Az eredeti ID-t kötelezően megtartjuk.
         */
        id: targetTable.id
      };

      /*
       * Csak az érintett tábla cserélődik.
       * Minden másik tábla változatlan marad.
       */
      const finalTables = sourceTables.map((candidate) =>
        String(candidate.id) === String(targetTable.id)
          ? regeneratedTarget
          : candidate
      );

      dispatch(updateTables(structuredClone(finalTables)));

      setEditedTables(structuredClone(finalTables));
      const replaySourceItems =
        Array.isArray(generated?.createdItems) &&
        generated.createdItems.length > 0
          ? generated.createdItems
          : normalizedItems;
      // Refresh the Dati row links together with the regenerated cut sections.
      const replayItems = replaySourceItems.map(item =>
        rebuildProcessed(item, parsePositions, makeInstanceIds)
      );
      setCreatedItems(structuredClone(replayItems));
      setProcessedItems(structuredClone(replayItems));
      setEditedItems(structuredClone(replayItems));

      if (generated?.work) {
        dispatch(updateWork(generated.work));
        pendingWorkRef.current = generated.work;
      }

      onDirty(true);

      return {
        items: replayItems,
        tables: finalTables
      };
    });

    if (!result) {
      throw new Error("GENERATION_OR_REPLAY_ALREADY_RUNNING");
    }

    return result;
  };
  const handleGenerateClick = () => {
    setPreprocessBeforeGenerate(!generatedWorkIdsRef.current.has(String(workId))
      && createdTables.length === 0 && workingTables.length === 0);
    setShowGenerateModal(true);
  };
  const handleConfirmedGenerate = async () => {
    if (generationRequestRef.current) return;
    generationRequestRef.current = true;
    setShowGenerateModal(false);

    const config = {
      scope: generateScope,
      mode: generateMode,
      colorIds: selectedGenerateColorIds,
      tableIds: selectedGenerateTableIds,
      TRIM: trimSize,
      direction: generateDirection,
      allowHalfTable
    };
    /*
    if (hasDirty) {
      pendingGenerateConfigRef.current = config;
      setShowPreGenerateSaveModal(true);
      return;
    }*/

    try {
      setIsLoading(true);
      if (preprocessBeforeGenerate) {
        if (hasDirty) await saveDirtyItemsIfAny();
        const changes = await workApi.preprocessWorkApi(workId);
        const source = originalItemsRef.current ?? createdItems;
        const geometryChanged = preprocessingChangesGeometry(source, changes);
        const merged = mergePreprocessedItems(source, changes).map((item) =>
          rebuildProcessed(item, parsePositions, makeInstanceIds)
        );
        originalItemsRef.current = structuredClone(merged);
        setCreatedItems(merged);
        setProcessedItems(merged);
        setEditedItems(merged);
        config.preprocessedItems = merged;
        if (geometryChanged) {
          config.scope = "work";
          config.mode = "full";
        }
      }
      await actuallyGenerate(config);
    } catch (error) {
      console.error("Generation/preprocessing failed:", error);
      showMessage("error", "Az előfeldolgozás vagy a táblagenerálás sikertelen. Próbáld újra.");
    } finally {
      generationRequestRef.current = false;
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    setCurrentTableIndex(0);
    setShowNoTableText(false);

    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [dispatch, workId]);

  // TableViewer komponensen belül
  const handleAddItem = async () => {
    if (isAddingItem) return; // 🔴 HARD GUARD

    setIsAddingItem(true);

    try {
      const defaultObjectId = objects[0].objectId;

      const payload = {
        size: "[1,1,18]",
        qty: 1,
        position: "[0,0,0]",
        rotation: "[0,0,0]",
        color: null,
        name: "",
        details: "",
        material: "",
        rotable: true,
        object: { objectId: +defaultObjectId },
        work: { workId: +workId },
        itemId: Date.now() * -1
      };

      const created = await dispatch(
        createdItemApi.createCreatedItemApi(payload)
      );

      if (!created) return;

      setCreatedItems((prev) => [
        ...prev,
        { ...created, color: created.color ?? null }
      ]);

      setEditedItems((prev) => [
        ...prev,
        { ...created, processedPositions: [] }
      ]);

      setProcessedItems((prev) => [
        ...prev,
        { ...created, processedPositions: [] }
      ]);
    } catch (err) {
      console.error("Hiba történt:", err);
    } finally {
      setIsAddingItem(false); // 🔥 KRITIKUS
    }
  };

  const isMDFColor = (colorId) => {
    const c = colorsFromStore.find((c) => c.colorId === colorId);
    return (
      String(c?.materialType ?? "")
        .trim()
        .toUpperCase() === "MDF"
    );
  };

  const filteredTables = workingTables
    .filter((t) => !isMDFColor(t.color?.colorId))
    .filter((t) =>
      selectedColorId !== null ? t.color?.colorId === selectedColorId : true
    );

  const currentTable =
    filteredTables.length > 0
      ? filteredTables[currentTableIndex % filteredTables.length]
      : null;

  const effectiveSelectedColorId =
    currentTable?.color?.colorId ?? selectedColorId ?? null;
  const handleNextTable = () => {
    setCurrentTableIndex((prev) => (prev + 1) % filteredTables.length);
  };

  const handlePrevTable = () => {
    setCurrentTableIndex(
      (i) => (i - 1 + filteredTables.length) % filteredTables.length
    );
  };
  useEffect(() => {
    if (currentTableIndex >= filteredTables.length) {
      setCurrentTableIndex(0);
    }
  }, [filteredTables.length]);
  const onItemChange = useCallback(
    (idx, updatedFields) => {
      handleCreatedItemChange(idx, updatedFields);
    },
    [handleCreatedItemChange]
  );
  const onItemColorChange = useCallback(
    (idx, color) => {
      handleCreatedItemChange(idx, {
        color: color ? { colorId: color.colorId } : null
      });
    },
    [handleCreatedItemChange]
  );
  const onDragEndCb = useCallback(
    (result) => {
      const { destination, draggableId } = result;
      if (!destination) return;

      // draggableId pl: "item-123"
      const itemId = Number(draggableId.replace("item-", ""));
      if (!itemId) return;

      const colorId =
        destination.droppableId === "no-color"
          ? null
          : Number(destination.droppableId);

      setCreatedItems((prev) =>
        prev.map((it) =>
          it.itemId === itemId
            ? { ...it, color: colorId ? { colorId } : null }
            : it
        )
      );

      onDirty(true);
    },
    [onDirty]
  );

  const onSwapCb = useCallback((sourceColorId) => {
    setSwapSourceColor(sourceColorId ?? null);
    setShowPaletteModal(true);
  }, []);

  const handleMouseDown = (e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startPosition = dividerPosition;

    const handleMouseMove = (moveEvent) => {
      const deltaX = moveEvent.clientX - startX;
      const newPosition = startPosition + (deltaX / window.innerWidth) * 100;
      setDividerPosition(Math.max(20, Math.min(80, newPosition)));
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  const isCompanyRole =
    currentUser?.role === "companyAdmin" || currentUser?.role === "companyUser";

  const readOnlyForGeneratedList = isCompanyRole
    ? selectedWork?.companyStatus === "Completed" // cég oldalon csak Completed esetén zárolunk
    : Boolean(isOrdered); // felhasználónál továbbra is a rendeltség zárol

  const startEditing = () => {
    setEditedTables(structuredClone(createdTables));
    setEditedItems(structuredClone(processedItems));
    setIsEditing(true);
  };
  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (!hasDirty) return;
      e.preventDefault();
      e.returnValue = "";
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => window.removeEventListener("beforeunload", onBeforeUnload);
  }, [hasDirty]);

  return (
    <div
      className="table-viewer"
      style={{ "--tv-divider-position-state": `${dividerPosition}%` }}
    >
      {/* Palette Modal for bulk color swap */}
      <ColorPickerModal show={showPaletteModal && canEdit} colors={colorsFromStore}
        onClose={closePalette} onSelect={(color) => selectPalettePatch({ color: { colorId: color.colorId } })}
        millings={millings} onSelectMilling={(milling, variantId, selectedColor) => selectPalettePatch({
          milling: milling ? { millingId: milling.millingId } : null,
          ...(selectedColor ? { color: { colorId: selectedColor.colorId } } : {}),
          millingId: milling?.millingId ?? null, millingVariantId: variantId || ""
        }, true)} />

      <Modal
        show={showPreGenerateSaveModal}
        onHide={() => setShowPreGenerateSaveModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("saveChangesTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("saveChangesBeforeGenerate")}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={async () => {
              try {
                await saveDirtyItemsIfAny(false);
                setShowPreGenerateSaveModal(false);
                if (pendingGenerateConfigRef.current) {
                  const cfg = pendingGenerateConfigRef.current;
                  pendingGenerateConfigRef.current = null;
                  await actuallyGenerate(cfg);
                }
              } catch (e) {
                console.error(e);
                alert(t("saveFailed"));
              }
            }}
          >
            {t("saveAndGenerate")}
          </Button>
          <Button
            variant="secondary"
            onClick={() => {
              // ha mégsem akarsz generálni, csak zárd
              setShowPreGenerateSaveModal(false);
            }}
          >
            {t("cancel")}
          </Button>
        </Modal.Footer>
      </Modal>

      <div ref={containerRef} className="table-viewer__main-pane">
        <TableViewerComponent
          onGenerate={handleGenerateClick}
          workId={workId}
          table={currentTable}
          createdTables={workingTables}
          items={isEditing ? editedItems : processedItems}
          containerRef={containerRef}
          onNext={handleNextTable}
          onPrev={handlePrevTable}
          selectedItemPosition={selectedItemPosition}
          setSelectedItemPosition={setSelectedItemPosition}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
          startEditing={startEditing}
          editedTables={editedTables}
          setEditedTables={setEditedTables}
          editedItems={editedItems}
          setEditedItems={setEditedItems}
          setCreatedItems={setCreatedItems}
          setProcessedItems={setProcessedItems}
          setCurrentTableIndex={setCurrentTableIndex}
          showNoTableText={showNoTableText}
          setShowNoTableText={setShowNoTableText}
          isLoading={isLoading}
          selectedColorId={selectedColorId}
          setSelectedColorId={setSelectedColorId}
          isExporting={isExporting}
          setIsExporting={setIsExporting}
          processedItems={processedItems}
          runWithLock={runWithLock}
          saveLock={saveLock}
          onDirty={onDirty}
          hasDirty={hasDirty}
          saveDirtyItemsIfAny={saveDirtyItemsIfAny}
          colorsFromStore={colorsFromStore}
          exportMode={exportMode}
          setExportMode={setExportMode}
          selectedColorIds={selectedColorIds}
          setSelectedColorIds={setSelectedColorIds}
          selectedTableIds={selectedTableIds}
          setSelectedTableIds={setSelectedTableIds}
          handleConfirmedExport={handleConfirmedExport}
          usedColors={usedColors}
          usedTables={usedTables}
          showExportModal={showExportModal}
          setShowExportModal={setShowExportModal}
          saveGeneratedTables={saveGeneratedTables}
          loadData={loadData}
          statusMessage={statusMessage}
          setIsLoading={setIsLoading}
          showMessage={showMessage}
          onSizeList={handleSizeListClick}
          generatedSavePendingRef={generatedSavePendingRef}
          placementItemId={placementItemId}
          setPlacementItemId={setPlacementItemId}
          placementRotation={placementRotation}
          setPlacementRotation={setPlacementRotation}
          placementForceRotate={placementForceRotate}
          setPlacementForceRotate={setPlacementForceRotate}
          onReplaySingleTable={replaySingleTable}
        />
        <ExportModal
          show={showExportModal}
          onClose={() => setShowExportModal(false)}
          exportMode={exportMode}
          setExportMode={setExportMode}
          usedColors={usedColors}
          selectedColorIds={selectedColorIds}
          setSelectedColorIds={setSelectedColorIds}
          usedTables={usedTables}
          selectedTableIds={selectedTableIds}
          setSelectedTableIds={setSelectedTableIds}
          onConfirm={handleConfirmedExport}
        />

        <GenerateModal
          preprocessBeforeGenerate={preprocessBeforeGenerate}
          setPreprocessBeforeGenerate={setPreprocessBeforeGenerate}
          show={showGenerateModal}
          onClose={() => setShowGenerateModal(false)}
          generateScope={generateScope}
          setGenerateScope={setGenerateScope}
          generateMode={generateMode}
          setGenerateMode={setGenerateMode}
          usedColors={usedColors}
          usedTables={usedTables}
          selectedColorIds={selectedGenerateColorIds}
          setSelectedColorIds={setSelectedGenerateColorIds}
          selectedTableIds={selectedGenerateTableIds}
          setSelectedTableIds={setSelectedGenerateTableIds}
          onConfirm={handleConfirmedGenerate}
          trimSize={trimSize}
          setTrimSize={setTrimSize}
          generateDirection={generateDirection}
          setGenerateDirection={setGenerateDirection}
          allowHalfTable={allowHalfTable}
          setAllowHalfTable={setAllowHalfTable}
        />
      </div>

      <div onMouseDown={handleMouseDown} className="table-viewer__divider" />

      <div className="table-viewer__side-pane">
        <div className="table-viewer__side-content">
          <div className="table-viewer__items-header">
            <div className="table-viewer__items-title-row">
              <h3 className="table-viewer__items-title">
                {t("createdItemsTitle")}
              </h3>

              {canEdit && (
                <Button
                  size="sm"
                  variant="outline-primary"
                  className="table-viewer__add-item-button"
                  onClick={handleAddItem}
                  disabled={isAddingItem}
                  title={t("addNewItem")}
                >
                  <span className="table-viewer__add-item-label-full">
                    {t("addNewItem")}
                  </span>
                </Button>
              )}
            </div>
          </div>
          <div className="table-viewer__right-panel">
            <TableItemsList
              generatedItems={isEditing ? editedItems : createdItems}
              tables={workingTables}
              colors={colorsFromStore}
              palette={palette}
              selectedColorId={effectiveSelectedColorId}
              readOnly={readOnlyForGeneratedList}
              placementItemId={placementItemId}
              placementRotation={placementRotation}
              canPlaceItems={Boolean(currentTable)}
              onRequestPlacement={handlePlacementRequest}
              onDragEnd={onDragEndCb}
              handleItemChange={onItemChange}
              handleItemColorChange={onItemColorChange}
              onDelete={handleDeleteItem}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableViewer;
